export default {
  setItems: (state, data) => {
    state.items.splice(0)

    // eslint-disable-next-line array-callback-return
    data.map(x => {
      state.items.push({
        id: x.id,
        original_url: x.original_url,
        converted_url: x.converted_url,
        visits: x.visits,
        created: x.created,
        user: x.user
      })
    })
  },
}
